import React from 'react'


const Spla = () => {
  return (
      <>
          
          <div className="video-background">
        
          <center className='sl' >
          <video autoPlay muted>
              <source  src='video/Divya.mp4' type='video/mp4'></source>
              </video>
              </center>
              </div>
         
      </>
  )
}

export default Spla
